import React from "react";

export default props => (
  <g
    style={{
      fontSize: props.fontSize ? props.fontSize : "45px"
    }}
  >
    <text
      className="heading heading-left"
      xmlSpace="preserve"
      textAnchor="middle"
      y="122"
      x="295"
      strokeWidth="0"
      stroke="null"
      fill={props.color ? props.color : "white"}
    >
      {props.left}
    </text>
    <text
      className="heading heading-right"
      xmlSpace="preserve"
      textAnchor="middle"
      y="122"
      x={298 + props.left.length * 16}
      strokeWidth="0"
      stroke="null"
      fill={props.color ? props.color : "white"}
    >
      {props.right}
    </text>
  </g>
);



// WEBPACK FOOTER //
// ./src/components/Text/HeadingLR.js